import React from 'react'
import { httpGetAsync } from '../../util'
import { launchTimestamp, timeApiUrl } from '../../config'

import './countdown.scss'

class Countdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      currentTime: null
    }
  }

  componentDidMount() {
    if (!this.timer) {
      this.getCurrentTime()
    }
  }


  getCurrentTime() {
    if (typeof window !== 'undefined') {
      const currentTime = +new Date()
      this.startTimer(currentTime)
      /*
      httpGetAsync(
        timeApiUrl,
        (currentTime) => {
          this.startTimer(Number(currentTime))
        },
        () => {
          const currentTime = +new Date()
          this.startTimer(currentTime)
        }
      )*/
    }
  }

  startTimer(time) {
    let timeElapsed = 0

    this.timer = setInterval(() => {
      timeElapsed += 1000

      this.setState({
        currentTime: time + timeElapsed
      })
    }, 1000)
  }

  parseTimeDiff(diff) {
    // const days = Math.ceil(diff / (3600 * 24 * 1000))
    const days = Math.floor(diff / (3600 * 24 * 1000))
    const hours = Math.floor((diff % (3600 * 24 * 1000)) / (3600 * 1000))
    const minutes = Math.floor((diff % 3.6e6) / 6e4)
    const seconds = Math.floor((diff % 6e4) / 1000)

    return { days, hours, minutes, seconds }
  }

  renderTime() {
    const localization = this.props.localization

    if (this.state.currentTime) {
      const diff = launchTimestamp - this.state.currentTime

      if (diff > 0) {
        const { days, hours, minutes, seconds } = this.parseTimeDiff(diff)

        return (
          <div className="countdown-wrapper">
            <div className="description">{ localization('global.applicationsStart') }</div>
            <div className="time-container">
              <span className="time-value">{ days }</span>
              <span className="time-description">{ localization('global.days') }</span>
              <span className="time-value">{ hours }</span>
              <span className="time-description">{ localization('global.hours') }</span>
              <span className="time-value">{ minutes }</span>
              <span className="time-description">{ localization('global.minutes') }</span>
              <span className="time-value">{ seconds }</span>
              <span className="time-description">{ localization('global.seconds') }</span>
            </div>
          </div>
        )
      } else {
        return (
          <div className="description centered">{ localization('global.applicationOpen') }</div>
        )
      }
    } else {
      return null
    }
  }

  render() {
    return (
      <div className="countdown-container">
        { this.renderTime() }
      </div>
    )
  }
}

export default Countdown


// WEBPACK FOOTER //
// ./src/components/Countdown/countdown.js